import { Suspense } from 'react';
import ErrorBoundary from 'unsubscribe-ui/components/base/loader/ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
const AsyncLoader = ({
  Component,
  loading = null
}) => {
  const wrappedComponent = props => /*#__PURE__*/_jsx(ErrorBoundary, {
    children: /*#__PURE__*/_jsx(Suspense, {
      fallback: loading,
      children: /*#__PURE__*/_jsx(Component, Object.assign({}, props))
    })
  });
  return wrappedComponent;
};
export default AsyncLoader;